import { Injectable } from '@angular/core';
import { HttpMethodType } from '@app/app.constant';
import { HttpCallService } from '@core/services/http-call.service';
import {
  IPendingApprovalCountResponse,
  ISubmitTherapyRequest,
  ITherapyRequestDetailResponse,
  IWorkflowRequestListResponse
} from '@app/models/form-triggers/form-trigger.model';
import { Observable } from 'rxjs';

const HttpServiceMethods = {
  SubmitSessionExtensionRequest: 'WorkflowRequest/SubmitSessionExtensionRequest',
  GetRequests: 'WorkflowRequest/GetRequests',
  DecideRequest: 'WorkflowRequest/DecideRequest',
  GetPendingApprovalCount: 'WorkflowRequest/GetPendingApprovalCount',
  SubmitTherapyRequest: 'WorkflowRequest/SubmitTherapyRequest',
  WithdrawRequest: 'WorkflowRequest/WithdrawRequest',
  GetTherapyRequestDetail: 'WorkflowRequest/GetTherapyRequestDetail'
};

@Injectable({
  providedIn: 'root'
})
export class WorkflowRequestService {

  constructor(private httpService: HttpCallService) { }

  public submitSessionExtensionRequest(activityGuid: string, contactGuid: string, amount: number, reason: string): Observable<string> {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.SubmitSessionExtensionRequest,
      { activityGuid, contactGuid, amount, reason }
    );
  }

  public getRequests(statuses: number[], page: number, pageSize: number): Observable<IWorkflowRequestListResponse> {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.GetRequests,
      { statuses, page, pageSize }
    );
  }

  /** decisionData: therapy requests only - the approver's answers (Allocated Sessions + "Completed by approver" fields). */
  public decideRequest(requestGuid: string, approve: boolean, note: string, decisionData: any[] = []): Observable<boolean> {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.DecideRequest,
      { requestGuid, approve, note, decisionData }
    );
  }

  /** One request (and one Requested enrolment) per contact; returns the request guids. */
  public submitTherapyRequest(request: ISubmitTherapyRequest): Observable<string[]> {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.SubmitTherapyRequest,
      request
    );
  }

  public withdrawRequest(requestGuid: string): Observable<boolean> {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.WithdrawRequest,
      { requestGuid }
    );
  }

  public getTherapyRequestDetail(requestGuid: string): Observable<ITherapyRequestDetailResponse> {
    return this.httpService.callService(
      HttpMethodType.GET,
      `${HttpServiceMethods.GetTherapyRequestDetail}/${requestGuid}`
    );
  }

  public getPendingApprovalCount(): Observable<IPendingApprovalCountResponse> {
    return this.httpService.callService(
      HttpMethodType.GET,
      HttpServiceMethods.GetPendingApprovalCount
    );
  }
}
